var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { Box, Button as MButton, useTheme, } from '@mui/material';
import { elevated, filled, outlined, text, tonal } from './styles';
export var variants = [
    'filled',
    'outlined',
    'text',
    'elevated',
    'tonal',
];
var variantStyleMap = {
    filled: filled,
    outlined: outlined,
    text: text,
    elevated: elevated,
    tonal: tonal,
};
export default React.forwardRef(function (props, ref) {
    var pfVariant = props.pfVariant, backgroundColor = props.backgroundColor, label = props.label, icon = props.icon, sx = props.sx, children = props.children, rest = __rest(props, ["pfVariant", "backgroundColor", "label", "icon", "sx", "children"]);
    var theme = useTheme();
    var defaultBackgroundColors = {
        filled: theme.palette.primary.main,
        elevated: theme.palette.common.white,
        outlined: 'transparent',
        tonal: theme.palette.secondary.main,
        text: 'transparent',
    };
    var defaultBackgroundColorHovers = {
        filled: theme.palette.primary.dark,
        elevated: theme.palette.neutral[90],
        outlined: theme.palette.neutral[90],
        tonal: theme.palette.secondary.dark,
        text: theme.palette.neutral[90],
    };
    var padding = icon ? '10px 24px 10px 16px' : '10px 24px';
    var buttonSX = pfVariant
        ? __assign(__assign(__assign({ padding: padding }, variantStyleMap[pfVariant]), { '&:hover': {
                backgroundColor: backgroundColor || defaultBackgroundColorHovers[pfVariant],
                filter: backgroundColor && 'brightness(0.8)',
            }, backgroundColor: backgroundColor || defaultBackgroundColors[pfVariant] }), sx) : sx;
    var content = useMemo(function () {
        if (label) {
            return (_jsxs(Box, __assign({ sx: { display: 'inline-flex', alignItems: 'center', gap: 1 } }, { children: [icon, label] })));
        }
        return children;
    }, [label, icon, children]);
    return (_jsx(MButton, __assign({ ref: ref, sx: buttonSX }, rest, { children: content })));
});
